import { Controller } from '@hotwired/stimulus';

// Keep the underlying player screen shortcut current while its map drawer saves.
export default class extends Controller {
  static targets = ['label'];
  static values = { characterId: Number, saveUrl: String };

  update({ detail }) {
    if (detail.saveUrl !== this.saveUrlValue) return;
    this.labelTarget.textContent = detail.characters.includes(this.characterIdValue) ? 'Move' : 'Place';
  }
}
